export default class FlowCommand {
  undo(): void {
    return
  }

  redo(): void {
    return
  }

  execute(): void {
    return
  }
}
